import {postError} from '../../../services/toastService';
import {useModal} from '../Modal';
import React, {useEffect} from 'react';
import useApiService from '../../../hooks/useApiService';
import {useNavigate} from 'react-router-dom';
import ROUTES from '../../../enum/Routes';
import {AuthenticateTanForAuszahlungResponse} from '../../../@types/services/apiService';
import useStore from '../../../hooks/useStore';
import {Zahlung} from '../../../@types/data/Darlehensdaten';
import LoadingContainer from '../../../containers/LoadingContainer';
import {useTokenHandlerCookies} from '../../../hooks/useTokenHandlerCookies';

const TokenVerification = () => {
    const {data, setModalOpen} = useModal();
    const {darlehenId, auftragsId, token} = data;
    const { authorizeTokenForAuszahlung } = useApiService();

    const navigate = useNavigate();

    const {activeDarlehen, updateActiveDarlehen} = useStore();

    const {deleteTransactionCookie} = useTokenHandlerCookies();

    const submitToken = async () => {
        authorizeTokenForAuszahlung(darlehenId, auftragsId, token)
            .then(async (response: AuthenticateTanForAuszahlungResponse) => {
                const {zahlung, maximalerAuszahlungsbetrag} = response;

                const updatedZahlungen: Array<Zahlung> = [...activeDarlehen.zahlungen, zahlung];

                await updateActiveDarlehen({
                    zahlungen: updatedZahlungen,
                    maximalerAuszahlungsbetrag: maximalerAuszahlungsbetrag,
                });

                setModalOpen(false);
                deleteTransactionCookie();

                navigate(`${ROUTES.DASHBOARD}/${darlehenId}/?tab=auszahlungen`, {
                    state: {message: 'Auszahlungsauftrag erfolgreich angelegt.', preventRedirect: true},
                });
            })
            .catch((errorMessage) => postError(errorMessage, {duration: 20000}))
            .finally(() => {
                setModalOpen(false);
            });
    };

    useEffect(() => {
        submitToken();
    }, []);

    return (
        <div className="modal__content" style={{height: 120}}>
            <div className="flex flex--margin-y flex--margin-x">
                <LoadingContainer
                    isLoading={true}
                    className="loading-container--standalone loading-container--bottom-margin"
                    contentClassName="loading-container__content--text-only"
                >
                    Ihre Auszahlung wird abgeschlossen.<br />Bitte warten Sie einen Moment und schließen Sie diese Seite nicht.
                </LoadingContainer>
            </div>
        </div>
    );
};

export default TokenVerification;
